import React, { useState } from 'react'
import { CiMail } from 'react-icons/ci'
import { MdOutlinePhone } from 'react-icons/md'
import { FaRegIdBadge } from 'react-icons/fa6'
import { CiCalendarDate } from 'react-icons/ci'
import { RiDeleteBin6Line } from 'react-icons/ri'

const EmployeeCard = ({
  name,
  post,
  id,
  photo,
  email,
  phone,
  joinDate,
  clicked,
  deleted,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isCloseButtonHovered, setIsCloseButtonHovered] = useState(false)

  const handleDelete = (e) => {
    e.stopPropagation()
    deleted()
  }

  const handleMouseEnter = () => {
    if (!isCloseButtonHovered) {
      setIsHovered(true)
    }
  }

  const handleCardClick = () => {
    if (!isCloseButtonHovered) {
      clicked()
    }
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
      className={`
        w-full max-w-md bg-gradient-to-br from-white to-cream
        border border-light_gray rounded-xl shadow-lg
        transform transition-all duration-500 ease-in-out
        ${isHovered ? 'scale-105 shadow-xl' : ''}
        cursor-pointer overflow-hidden
      `}
    >
      {/* Header with gradient overlay */}
      <div className='h-24 bg-gradient-to-r from-gold to-rust relative'>
        <div className='absolute inset-0 bg-opacity-20 bg-white'>
          <div className='flex justify-end text-white p-4'>
            <RiDeleteBin6Line
              onClick={handleDelete}
              onMouseEnter={() => setIsCloseButtonHovered(true)}
              onMouseLeave={() => setIsCloseButtonHovered(false)}
              size={24}
              className='hover:scale-110 transition-transform duration-300'
            />
          </div>
        </div>
      </div>

      {/* Photo Section - Overlapping the header */}
      <div className='relative -mt-16 flex justify-center'>
        <div
          className={`
            w-32 h-32 rounded-full border-4 border-white shadow-lg
            overflow-hidden transition-transform duration-500
            ${isHovered ? 'scale-110' : ''}
          `}
        >
          <img
            src={
              photo ||
              'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
            }
            alt={`${name}'s Photo`}
            className='h-full w-full object-cover'
          />
        </div>
      </div>

      {/* Employee Info */}
      <div className='px-6 py-4 text-center'>
        <h2 className='text-2xl font-bold text-black mb-2'>
          {name || 'Employee Name'}
        </h2>
        <p className='text-gold font-semibold mb-4'>{post || 'Level'}</p>

        {/* Details with icons */}
        <div className='space-y-3'>
          <div className='flex items-center justify-center space-x-2'>
            <FaRegIdBadge className='w-4 h-4 text-muted_green' />
            <span className='text-black'>ID: {id || 'N/A'}</span>
          </div>

          <div className='flex items-center justify-center space-x-2'>
            <CiMail className='w-4 h-4 text-muted_green' />
            <span className='text-black'>{email || 'N/A'}</span>
          </div>

          <div className='flex items-center justify-center space-x-2'>
            <MdOutlinePhone className='w-4 h-4 text-muted_green' />
            <span className='text-black'>{phone || 'N/A'}</span>
          </div>

          <div className='flex items-center justify-center space-x-2'>
            <CiCalendarDate className='w-4 h-4 text-muted_green' />
            <span className='text-black'>Joined: {joinDate || 'N/A'}</span>
          </div>
        </div>
      </div>

      {/* Footer with subtle gradient */}
      <div className='mt-4 h-2 bg-gradient-to-r from-gold to-rust opacity-75' />
    </div>
  )
}

export default EmployeeCard
